/** @format */

import * as React from "react";
import { captureUtmParams } from "../lib/tracking";

/** Captures ad click attribution params site-wide on first load. */
const TrackingBootstrap = () => {
  React.useEffect(() => {
    captureUtmParams();
  }, []);

  return null;
};

export default TrackingBootstrap;
